import { type RibbonIconColor } from "owa-command-ribbon/lib/util/ribbonIconModeColors";
import { type IconColorMap } from "owa-command-ribbon/lib/util/getRibbonIconColor";
import { type HelpRibbonControlId } from "owa-ribbon-ids/lib/helpControlId";

export const HelpTabIconColorMap: IconColorMap = new Map([
    [11201, 1],
    [11210, 4],
    [11202, 4],
    [11203, 3],
    [11204, 5],
]);
